import React, { useMemo } from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { useResponseContext } from 'js/engines/CapabilitiesAssessment/ResponseContext';

function StandardQuestionsPageIndicator({ className, page }) {
  const { questionMap, responses } = useResponseContext();

  const questions = useMemo(() => {
    return (page.elements ?? [])
      .map((element) => questionMap[element.key])
      .filter((question) => !!question)
      .map((question) => ({
        id: question.id,
        answered: !!responses[question.id],
      }));
  }, [page.elements, questionMap, responses]);

  const classes = useMemo(() => {
    return classNames('page-indicator', 'question-set', className);
  }, [className]);

  return (
    <Link
      to={`./${page.guid}`}
      className={classes}
      style={{ flexGrow: questions.length }}
    >
      {questions.map(({ id, answered }) => (
        <span key={id} className={classNames('question', { answered })}></span>
      ))}
    </Link>
  );
}

export default StandardQuestionsPageIndicator;
